import { Card } from "@/components/ui/card";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { Link } from "react-router";

interface Activity {
  id: number;
  type: "income" | "expense";
  description: string;
  amount: number;
  date: string;
  category?: string;
  link?: string;
}

interface RecentActivityCardProps {
  title: string;
  activities: Activity[];
}

import * as React from "react";
export const RecentActivityCard = ({ title, activities }: RecentActivityCardProps) => {
  return (
    <Card className="p-6 bg-gradient-to-br from-card-gradient-start to-card-gradient-end border-border/50">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
      </div>
      <div className="space-y-3">
        {activities.map((activity) => {
          const content = (
            <div className="flex items-center justify-between p-3 rounded-lg bg-card/50 hover:bg-card/80 transition-colors w-full">
              <div className="flex items-center gap-3">
                <div
                  className={`p-2 rounded-full ${
                    activity.type === "income"
                      ? "bg-success/10 text-success"
                      : "bg-destructive/10 text-destructive"
                  }`}
                >
                  {activity.type === "income" ? (
                    <ArrowDownLeft size={16} />
                  ) : (
                    <ArrowUpRight size={16} />
                  )}
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground">
                    {activity.description}
                  </p>
                  <p className="text-xs text-muted-foreground">{activity.date}</p>
                </div>
              </div>
              <div className="text-right">
                <p
                  className={`text-sm font-semibold ${
                    activity.type === "income" ? "text-success" : "text-destructive"
                  }`}
                >
                  {activity.type === "income" ? "+" : "-"}₹
                  {activity.amount.toLocaleString("en-IN")}
                </p>
                {activity.category && (
                  <p className="text-xs text-muted-foreground">{activity.category}</p>
                )}
              </div>
            </div>
          );

          if (activity.link) {
            return (
              <Link to={activity.link} key={activity.id} className="block">
                {content}
              </Link>
            );
          }
          return <React.Fragment key={activity.id}>{content}</React.Fragment>;
        })}
      </div>
    </Card>
  );
};
